export enum ErpPhase {
    Assessments_In_Progress = 'Assessments_In_Progress',
    Site_Assessment         = 'Site_Assessment',
    Remedial_Implementation = 'Remedial_Implementation',
    OM_M                    = 'OM_M',
    Closure                 = 'Closure',
    Groundwater             = 'Groundwater',
    Assess_Obligation       = 'Assess_Obligation',
    Business_Case           = 'Business_Case',
    Litigation              = 'Litigation',
    Inactive                = 'Inactive',
}

export const ErpPhaseLabels: Record<ErpPhase, string> = {
    [ErpPhase.Assessments_In_Progress]: 'Assessments In-Progress',
    [ErpPhase.Site_Assessment]:         'Site Assessment',
    [ErpPhase.Remedial_Implementation]: 'Remedial Implementation',
    [ErpPhase.OM_M]:                    'OM&M',
    [ErpPhase.Closure]:                 'Closure',
    [ErpPhase.Groundwater]:             'Groundwater',
    [ErpPhase.Assess_Obligation]:       'Assess Obligation',
    [ErpPhase.Business_Case]:           'Business Case',
    [ErpPhase.Litigation]:              'Litigation',
    [ErpPhase.Inactive]:                'Inactive',
};
